import {
  RECORD_SURVEY_ENTRY_REQUEST,
  RECORD_SURVEY_ENTRY_SUCCESS,
  RECORD_SURVEY_ENTRY_FAILURE,
  RECORD_SURVEY_ENTRY_RESET,
  GET_RESPONDENT_REQUEST,
  GET_RESPONDENT_SUCCESS,
  GET_RESPONDENT_FAILURE,
  GET_RESPONDENT_RESET,
} from '../actions/surveyRespondentAction';

const initialState = {
  recordSurveyEntryState: {
    apiState: '',
    data: null,
    message: '',
  },
  getRespondentState: {
    apiState: '',
    data: null,
    message: '',
  },
};

const surveyRespondentReducer = (state = initialState, action) => {
  switch (action.type) {
    case RECORD_SURVEY_ENTRY_REQUEST:
      return {
        ...state,
        recordSurveyEntryState: {
          apiState: 'loading',
          data: null,
          message: '',
        },
      };
    case RECORD_SURVEY_ENTRY_SUCCESS:
      return {
        ...state,
        recordSurveyEntryState: {
          apiState: 'success',
          data: action.response,
          message: action.response?.message || 'Survey entry recorded successfully',
        },
      };
    case RECORD_SURVEY_ENTRY_FAILURE:
      return {
        ...state,
        recordSurveyEntryState: {
          apiState: 'error',
          data: null,
          message: action.error,
        },
      };
    case RECORD_SURVEY_ENTRY_RESET:
      return {
        ...state,
        recordSurveyEntryState: {
          apiState: '',
          data: null,
          message: '',
        },
      };

    case GET_RESPONDENT_REQUEST:
      return {
        ...state,
        getRespondentState: {
          apiState: 'loading',
          data: null,
          message: '',
        },
      };
    case GET_RESPONDENT_SUCCESS:
      return {
        ...state,
        getRespondentState: {
          apiState: 'success',
          data: action.response,
          message: action.response?.message || 'Respondent retrieved successfully',
        },
      };
    case GET_RESPONDENT_FAILURE:
      return {
        ...state,
        getRespondentState: {
          apiState: 'error',
          data: null,
          message: action.error,
        },
      };
    case GET_RESPONDENT_RESET:
      return {
        ...state,
        getRespondentState: {
          apiState: '',
          data: null,
          message: '',
        },
      };

    default:
      return state;
  }
};

export default surveyRespondentReducer;
